import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from '@/providers/QueryProvider';
import { I18nProvider } from '@/hooks/useI18n';
import { Toaster } from '@/components/ui/toaster';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { VersionChecker } from '@/components/common/VersionChecker';
import { AuthBootstrap } from '@/components/common/AuthBootstrap';
import { ScrollToTop } from '@/components/common/ScrollToTop';
import AppRoutes from '@/routes/index';

/**
 * Root application component.
 *
 * Provider wrapping order:
 * HelmetProvider → QueryProvider → I18nProvider → ErrorBoundary → BrowserRouter → AuthBootstrap → AppRoutes
 *
 * ScrollToTop sits directly under BrowserRouter so every navigation starts at
 * the top of the page instead of inheriting the previous page's scroll offset.
 *
 * AuthBootstrap performs a silent token refresh on load so a page reload can
 * restore the session from the httpOnly refresh cookie (tokens are never
 * persisted to localStorage, req 4.5).
 */
export default function App() {
  return (
    <HelmetProvider>
      <QueryProvider>
        <I18nProvider>
          <ErrorBoundary>
            <BrowserRouter>
              <ScrollToTop />
              <AuthBootstrap>
                <AppRoutes />
              </AuthBootstrap>
              <Toaster />
              <VersionChecker />
            </BrowserRouter>
          </ErrorBoundary>
        </I18nProvider>
      </QueryProvider>
    </HelmetProvider>
  );
}
